// Usando o JSON fornecido diretamente e adaptando-o
export const rawCategoriasData: any = {
  disciplinas_academicas: [
    {
      id: "matematica",
      nome: "Matemática",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ah5mfl0ajp1749403429475",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ukfveypvgvj1749403434389",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/0gz3coautie91749403430335",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/03917i5hsuss1749403428168",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ikzjeoh28v1749403434684",
      ],
      subcategorias: [
        {
          id: "algebra",
          nome: "Álgebra",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/c856a8l3vll1749403476725",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/v1e945th2z1749403472298",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mjzmy8rs7q1749403473507",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/1f4g5639rs11749403480408",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/f87lb5l831f1749403476711",
          ],
        },
        {
          id: "geometria",
          nome: "Geometria",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/gxcl5gnsyjs1749403532585",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/unjunquwgw1749403534342",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ax6srsupjhj1749403529834",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/qsiq6q9u49l1749403536490",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mlhv6pwt4v1749403538032",
          ],
        },
        {
          id: "trigonometria",
          nome: "Trigonometria",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xolwqi7ypt81749403611402",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/fxbz8hhpet1749403604017",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/qyw6td0krd91749403602360",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xu8o5cvegd1749403605470",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/zbyalzyyvkk1749403603564",
          ],
        },
        {
          id: "estatistica",
          nome: "Estatística",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/a0zf72c6xie1749403704860",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/cr1jbjil31k1749403696305",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xlnyydo7oz1749403701272",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/yeer8i6yo1c1749403695847",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nuaaq96mpwb1749403696785",
          ],
        },
        {
          id: "equacoes",
          nome: "Equações",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/5k6w00axkbw1749403766529",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/1y9zd1x2j8p1749403767627",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/t569i6qmi7b1749403776343",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/j4sgr1fl3mo1749403797379",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/oslaaz2nwv1749403773463",
          ],
        },
        {
          id: "aritmetica",
          nome: "Aritmética",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/rn8q9r4l71k1751462927780",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/25jkgpdqapq1751462923242",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/sp4fqjjfpb1751462922413",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/gf5is4tlzsu1751462924091",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/4o96ny8newa1751462922106",
          ],
        },
        {
          id: "calculo",
          nome: "Cálculo",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/37k0n9w97ub1751462952394",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/yj16v3hr2vd1751462956233",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/9we3rt136zu1751462949323",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/tzj1i5xfffg1751462947042",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/2kbw4p4d1ay1751462951465",
          ],
        },
        {
          id: "funcoes",
          nome: "Funções",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/zjyo3x4hkwo1751462980213",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/5s26k8okp7d1751462976028",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/46c0ykh5acl1751462980098",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/2iiy762rp6u1751462983679",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/gci0v4qjnui1751462978310",
          ],
        },
        {
          id: "probabilidade",
          nome: "Probabilidade",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/kln7qh2fsoh1751463006367",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/23eelmtfywx1751463003850",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/q44vdno4i41751463008134",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/9v27u7mhfr51751463006110",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ia2pvff54vs1751463007300",
          ],
        },
        {
          id: "logica_matematica",
          nome: "Lógica Matemática",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/a9gnvixdsk91751463033817",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/fhmh6fs2ivp1751463033922",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/3epj53rsmzn1751463036817",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/z74irkbv2v1751463037999",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/bye8290o57w1751463036704",
          ],
        },
      ],
    },
    {
      id: "portugues",
      nome: "Português",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/j0olnmlb41d1749403900518",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mjwnbsptg41749403906370",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/uvbcbfk6cxq1749403903407",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/l82uii8h0a1749403905122",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/c8cbplu0p381749403906675",
      ],
      subcategorias: [
        {
          id: "gramatica",
          nome: "Gramática",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/khnrmd55kp1749403981188",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/zcgcdw6caqb1749403975002",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/hgqyctqi35n1749403972892",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/wdom738yohp1749403978123",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/qync4t5b29k1749403971452",
          ],
        },
        {
          id: "redacao",
          nome: "Redação",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ztgcpk1tewl1749404004149",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/7766zrrqxtq1749404004956",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/le2g6e2zxm1749404002060",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/6801rizpw2y1749404001259",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/upxaiilqf91749404002013",
          ],
        },
        {
          id: "ortografia",
          nome: "Ortografia",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/23mam97pck1749404042608",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/08trhu8bh9mu1749404040824",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/non74dle1h1749404066121",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/j7ohxx3hm0c1749404046709",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/dobyl90w1nb1749404045071",
          ],
        },
        {
          id: "verbos",
          nome: "Verbos",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/3osakgcek771749404091377",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/blgnse1y9qe1749404094792",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/m36k33aenns1749404098408",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/41pdnkidis71749404095653",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/gos9us03tuc1749404091199",
          ],
        },
        {
          id: "literatura_portugues",
          nome: "Literatura",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/kdrsz2ue29k1751463062337",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/p4m2qrbdoo1751463066165",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/y6zp6qyxa41751463070430",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/pwh79mf4z5c1751463061564",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/arbniq3skzi1751463059999",
          ],
        },
        {
          id: "interpretacao_texto",
          nome: "Interpretação de Texto",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/l0tzxmiy77q1751463096653",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/3t50vzh0ivn1751463090516",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/idyjbiggkk1751463093972",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/v1owewjqgs1751463095916",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/2k1kzkt2yr91751463092228",
          ],
        },
        {
          id: "sintaxe",
          nome: "Sintaxe",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/cxmea8vjtd1751463122108",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/7kmxx62hzzt1751463124327",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/1zo2b93xad21751463123271",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/a105s7hu3fa1751463118414",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/sea5fzjyop1751463130056",
          ],
        },
        {
          id: "morfologia",
          nome: "Morfologia",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/dyupbixd1wq1751463151521",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/59tiiogksia1751463149905",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/um2w91hqf0c1751463151484",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/4fzceo0238y1751463163953",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/fzi5d7yqdzp1751463156671",
          ],
        },
        {
          id: "pontuacao",
          nome: "Pontuação",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/l423f33w0yn1751463184341",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/9y4w9qsybn1751463187944",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/z9oacmltq1751463184968",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/l0tzscvjil1751463192220",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/wmr9j6tr1bf1751463196217",
          ],
        },
        {
          id: "figuras_linguagem",
          nome: "Figuras de Linguagem",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/hnt9cxl8m9n1751463243480",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/uayk34xodf91751463261646",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/oepfu31i8ol1751463242844",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/gmgrrt72y4c1751463241404",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/h37f12fscu41751463237988",
          ],
        },
      ],
    },
    {
      id: "ciencias",
      nome: "Ciências",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/v5xuu4lirk81749404147377",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/d7ko1bsd3t51749404147849",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mwi53h83dun1749404146296",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/yqwzeosvi8i1749404147019",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ah8epluq5e1749404146006",
      ],
      subcategorias: [
        {
          id: "metodo_cientifico",
          nome: "Método Científico",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ckdsdzsd07w1751463316557",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/kouy91kzp1751463291435",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/6mr0fhb4rh91751463283825",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/zc474vkv4s1751463291947",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mpruj36t5j1751463282624",
          ],
        },
        {
          id: "laboratorio",
          nome: "Laboratório",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/vs5uzakumm1751463344788",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/c8b675uxxxa1751463343337",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/tawdxv8yg1751463339894",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/p9ecpklrla1751463342613",
          ],
        },
        {
          id: "medicao",
          nome: "Medição",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/t8qh1o2whx1751463383130",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/tlz532gebmp1751463383899",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ullaqbp9v5q1751463379754",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/0l7nhihpov1a1751463379696",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/2xwcepz1zfi1751463379922",
          ],
        },
        {
          id: "experimentacao",
          nome: "Experimentação",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/rrtgs1prijm1751463461588",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/va9txfc9fdq1751463460243",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/obkroto6wn1751463460233",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/eawozpimsge1751463457349",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/aat8r6zq32n1751463456412",
          ],
        },
        {
          id: "observacao",
          nome: "Observação",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/wmguzejjnmc1751463496261",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/upu38us5yhm1751463499056",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/q60ygedjab1751463497552",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/otokfqhtd31751463495099",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/sayq1imx481751463494008",
          ],
        },
        {
          id: "hipoteses",
          nome: "Hipóteses",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/0dgv00k2ru5q1751463528427",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mwzh1zgddl1751463525238",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/9y3js74whp1751463520077",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/tp02vfr5171751463527920",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/qik1cy79qta1751463523950",
          ],
        },
        {
          id: "teorias",
          nome: "Teorias",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xuzvednesrn1751463567403",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/m1o92mugvg1751463554270",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/og2sv721b71751463556510",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/wodj8h2mu61751463558828",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/abz02xk94as1751463547929",
          ],
        },
        {
          id: "pesquisa",
          nome: "Pesquisa",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/j9aiwy286w1751463592737",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8nlauqwwt191751463590555",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/bnmfwljdta81751463588221",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/of0plyniul1751463597733",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/3y6egjf1qbp1751463594615",
          ],
        },
        {
          id: "tecnologia_ciencias",
          nome: "Tecnologia",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/elgw8qr6sg61751463619496",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/g6x4obrj811751463623499",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xwg0jk702xj1751463616931",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/dmecdbqie661751463619346",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/73t8j3p5oso1751463621526",
          ],
        },
        {
          id: "ciencias_aplicadas",
          nome: "Ciências Aplicadas",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/e61ze06nve71751463646533",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/lzsipgh5ysr1751463645206",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/6galkqpt0f21751463648561",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/uzffak95x81751463648608",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xyp9175zog1751463653714",
          ],
        },
      ],
    },
    {
      id: "biologia",
      nome: "Biologia",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/1ldglnk2mlg1749404200767",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/4u9oj0op0251749404184496",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/16ti2fv085u1749404186309",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/199xoezuntz1749404188688",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/gesp0ut2jp61749404188082",
      ],
      subcategorias: [
        {
          id: "celulas",
          nome: "Células",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/95x3heeawur1749404224014",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/1ulmbjy60s51749404224639",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xph6k3c1ym91749404228424",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xqwk2yv9dn1749404225899",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/rcl13u32ha1749404221983",
          ],
        },
        {
          id: "corpo_humano",
          nome: "Corpo Humano",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/zr4xesnf6oj1749404261630",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/cbt8voaxl9o1749404257261",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/98ozem19p41749404256799",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/kx2kyc1hx3r1749404258674",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/wvukgbcdwp1749404262050",
          ],
        },
        {
          id: "zoologia",
          nome: "Zoologia",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/eeriybs6abi1749404296982",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/lpx69vaf1z1749404296266",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/e5vzd1rggy1749404294232",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/zwugrloa2fd1749404298386",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/k9ybb1hfw81749404296743",
          ],
        },
        {
          id: "botanica",
          nome: "Botânica",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8lgpu17tphc1749404325564",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/5p9bv48j8rx1749404326036",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xtk9piw71j1749404330296",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/on8m1ail3b81749404327018",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/527nekywbpo1749404329442",
          ],
        },
        {
          id: "genetica",
          nome: "Genética",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nj5i6w6oqg1751463690283",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/kc9apjp8gz1751463688636",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/417ruq259i41751463681233",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/lxydoqtdte81751463688896",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/qp34q2ig8c1751463681729",
          ],
        },
        {
          id: "evolucao",
          nome: "Evolução",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/28xfta0ns2x1751463711183",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xr8gexjgowb1751463714177",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ubs2grm0d8q1751463715714",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/wjcweife7rn1751463710889",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/srli1dlxv11751463717198",
          ],
        },
        {
          id: "ecologia",
          nome: "Ecologia",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/db9elgtfspa1751463745550",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nu1aice7no1751463744308",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/e7vorcc3ha1751463742424",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nlrxa688obh1751463737175",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/srj2z1k9iyd1751463739932",
          ],
        },
        {
          id: "microbiologia",
          nome: "Microbiologia",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/5rj1acxtn6e1751463767066",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/r8s1dlet1gn1751463771544",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/cgmcqldnp51751463766472",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/0bl3dcyvvunk1751463767638",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mrmadkxymoa1751463765344",
          ],
        },
        {
          id: "anatomia",
          nome: "Anatomia",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/hbgmbgf0cgk1751463793050",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/su6pecdppk1751463791354",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/rzxq0bw9f1b1751463791586",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/drfn5pwntmv1751463798782",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/zjrpy8mkvl71751463793428",
          ],
        },
        {
          id: "fisiologia",
          nome: "Fisiologia",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/twwq857u9ao1751463823898",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/g6wjaqvvv5u1751463819748",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jks525x8jrp1751463822324",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/odwv7dkp25f1751463825560",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ovvmxpi98gi1751463817763",
          ],
        },
        {
          id: "biotecnologia",
          nome: "Biotecnologia",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/av5eehf0c5t1751463859096",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/a6jj3t4f2ji1751463844952",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/zki6k07sx7n1751463847127",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/5qji4lqz7391751463848837",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8na36bjq2z91751463848830",
          ],
        },
        {
          id: "biologia_molecular",
          nome: "Biologia Molecular",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jb5chzml0to1751463891736",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/my5pj5gc2b1751463881025",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/v59s7yy6ej1751463881584",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/azk9nxs3mj51751463884502",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/orvelm9d5h1751463880702",
          ],
        },
      ],
    },
    {
      id: "fisica",
      nome: "Física",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/2xk5yhc8ls51749404373885",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/530o8e4j17c1749404374728",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/qcn290byqr81749404367099",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8553gmq1qdy1749404366250",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/s7xibh9wdl1749404367644",
      ],
      subcategorias: [
        {
          id: "mecanica",
          nome: "Mecânica",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/rnbkyk8onph1751463913501",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/tet9378vj791751463917504",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ytwrutlxty81751463916716",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/1w0fpk9kp4p1751463919204",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/uxvu7pavoo1751463920986",
          ],
        },
        {
          id: "termodinamica",
          nome: "Termodinâmica",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/u8h6gwqbf31751463944929",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mphjfuu55v1751463943135",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8jya9s1wk5f1751463941436",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/2qn5y1x9mw81751463951912",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/x5z7be8rkde1751463942318",
          ],
        },
        {
          id: "eletromagnetismo",
          nome: "Eletromagnetismo",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/4yr999mdth81751463979356",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/gyb0yo5a4hv1751463977115",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nnrgrvkao2r1751463979107",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/cgps76rx6b41751463973632",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/cnb5qkvw7j41751463974638",
          ],
        },
        {
          id: "optica",
          nome: "Óptica",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/rasgzbyia6m1751464000375",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/acoz2pd2bi1751464001677",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/yucqua7bba1751464001081",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/naa3cu4k9d1751464006007",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/e00evb22x11751464005405",
          ],
        },
        {
          id: "ondas",
          nome: "Ondas",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/o87fzaxkk2b1751464033158",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/irkn6ddjwv81751464034790",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/lwz9h8qgye1751464026635",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/7i5fq22p66t1751464037651",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xto9qjn92wb1751464035753",
          ],
        },
        {
          id: "fisica_moderna",
          nome: "Física Moderna",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/zl2dujhu17c1751464062634",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/vnlzl6nc10q1751464059385",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/kzvmw4qf3z1751464061111",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/lym8x70s8o1751464058223",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/w0vwy7mr3k1751464060285",
          ],
        },
        {
          id: "fisica_quantica",
          nome: "Física Quântica",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/atin81u0wnq1751464091805",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/m5cysgrawsh1751464091050",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/52z31be6pkh1751464092094",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/hi5rrq19q151751464088049",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/9rzqqt4mys61751464084135",
          ],
        },
        {
          id: "relatividade",
          nome: "Relatividade",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/lwygbgzin81751464113566",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jmp7qm2e5qg1751464121152",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/am7kuib764h1751464113336",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/3eq8tg97ex1751464117340",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ic9jppvlvss1751464122812",
          ],
        },
        {
          id: "fisica_nuclear",
          nome: "Física Nuclear",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/90jampao0cr1751464144001",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/l62fytupej71751464146722",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8syj478wvr81751464145286",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ujsc3mpu731751464152947",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/0o5rqf2jb67r1751464145777",
          ],
        },
        {
          id: "acustica",
          nome: "Acústica",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/k0chi9gd0m1751464182897",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/utr9fu79hhq1751464175098",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/6vkycu7cy291751464208221",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/u1pkn2r0exk1751464176348",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/iwj8xixr28b1751464173778",
          ],
        },
      ],
    },
    {
      id: "quimica",
      nome: "Química",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/y713eyic8pc1749404429341",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/qazv8hfngh1749404423915",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/evlwm6bhwr1749404426052",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/bjlyasq1oj1749404428012",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/wtovbjteyp91749404430973",
      ],
      subcategorias: [
        {
          id: "tabela_periodica",
          nome: "Tabela Periódica",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/berww4rg2381749404474399",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nukbe9l5nj1749404470637",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/oowrec2w6cd1749404474717",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/2m726efjdgv1749404467674",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/889rc5q72uy1749404472453",
          ],
        },
        {
          id: "ligacoes_quimicas",
          nome: "Ligações Químicas",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/dwbonpcer6p1751464227666",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/wmiy592vknp1751464231106",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nnexuv5sa6q1751464228982",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/59a8rutek2v1751464237145",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/m6bobgsaohq1751464236774",
          ],
        },
        {
          id: "quimica_organica",
          nome: "Química Orgânica",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/wrdrl7zitcn1751464265157",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/7c0pt7ukwnk1751464264407",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/tof110riz61751464267077",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ms5oyewlh21751464262991",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/txxljlq8bih1751464271583",
          ],
        },
        {
          id: "quimica_inorganica",
          nome: "Química Inorgânica",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/us046wc6dz1751464299635",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/pjc9lb6klm1751464293284",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/70xbirgehil1751464293114",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/zsic4hk85j71751464298322",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nftmz8o24a1751464290326",
          ],
        },
        {
          id: "estequiometria",
          nome: "Estequiometria",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/7xnlrwy3qfh1751464319775",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/4aeu04s3nlo1751464324157",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/lr74590w06a1751464325525",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/315torurm381751464322374",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/4sfikg2si4t1751464320471",
          ],
        },
        {
          id: "termoquimica",
          nome: "Termoquímica",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ll7hhk0wvs81751464349896",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/4659jos3nsw1751464350132",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/6uirt9e56v1751464352610",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/7q8ri0hnog1751464352858",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/gj6vyj05bd51751464351613",
          ],
        },
        {
          id: "cinetica_quimica",
          nome: "Cinética Química",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mrxxrnv4rs1751464377242",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ggz3r8co2qa1751464376150",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/h9cw0nhc25u1751464376191",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/oyrpwykt6m1751464374517",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/btx9q3ecy1a1751464437495",
          ],
        },
        {
          id: "equilibrio_quimico",
          nome: "Equilíbrio Químico",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/glts2dxnll41751464457942",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/j8vxo92ewml1751464468401",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/tc74xa3ovwc1751464460685",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/g0fxmo6p8hw1751464459082",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/c2lpgww6m61751464461722",
          ],
        },
        {
          id: "eletroquimica",
          nome: "Eletroquímica",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/gjxfp29i6ns1751464495694",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/d9h58imse891751464494060",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/sra6dypqtbg1751464499036",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/rkmuyz3v6g1751464496134",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/gpfnfkzsxzd1751464492931",
          ],
        },
        {
          id: "quimica_analitica",
          nome: "Química Analítica",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/tjgeqxyew51751464530046",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/te1hjz5ovu1751464530380",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/1znk5lhrnsa1751464531294",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/knxnou2i71m1751464529317",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/h2r15v8il0c1751464528040",
          ],
        },
      ],
    },
    {
      id: "astronomia",
      nome: "Astronomia",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xwa2ebgmv0f1749404504157",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nt1okkunpq1749404508458",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/dt27zvc11ls1749404501302",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/7um0dt4ydh31749404503985",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xytvxd7cqm1749404505893",
      ],
      subcategorias: [
        {
          id: "sistema_solar",
          nome: "Sistema Solar",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/vwkyjn3cd5p1749404542204",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/1xwinsarrd91749404545903",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/x0oytvwlzg1749404540921",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/c0cbv5lmiw1749404545726",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ugaxb9d7bo1749404542347",
          ],
        },
        {
          id: "ecossistemas",
          nome: "Ecossistemas",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/rxfj0k2dcs1749404582844",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/m15h13z5ste1749404579584",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8ed3mpeam9o1749404573784",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/tx884nslzaf1749404573661",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/145dmhakjd7h1749404579714",
          ],
        },
        {
          id: "galaxias",
          nome: "Galáxias",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/eex1dadxhg61751464563429",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/6chvyorqcjf1751464571000",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mps9ee72671751464561919",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/sa2ltsgrqsl1751464561252",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/kgxqwqq6p9o1751464561493",
          ],
        },
        {
          id: "estrelas",
          nome: "Estrelas",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/blg66bju1zh1751464595759",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/66tyhqskc5o1751464594483",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/vqse2air7sq1751464594050",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/t1u50qil55k1751464599718",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/q20d8uf62wg1751464597925",
          ],
        },
        {
          id: "planetas_exoplanetas",
          nome: "Planetas e Exoplanetas",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/hmwlrqs10b1751464628072",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/by97etshso1751464626603",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/i9852vhsdlj1751464630667",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/kfsfppdfzf91751464629951",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/fy953hqjr71751464622725",
          ],
        },
        {
          id: "buracos_negros",
          nome: "Buracos Negros",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/f8ofr2759wp1751464650004",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/yk6hgo3hlgq1751464651116",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/tsqs1c76ax1751464658810",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ydze2yurei1751464653189",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/i3iu9rq52c1751464652233",
          ],
        },
        {
          id: "cosmologia",
          nome: "Cosmologia",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ntgk0buccbn1751464679682",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jiul1ssra21751464680644",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/19g0vku23gw1751464684990",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/1v8aqh27l1k1751464679246",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ed104xqqrl61751464682178",
          ],
        },
        {
          id: "astrofisica",
          nome: "Astrofísica",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/uow8nplfyod1751464705121",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/vkfkft5d6hf1751464706903",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/redeyvlfefb1751464710132",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ba4k99k27891751464706746",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/x4zr63zcwj1751464704698",
          ],
        },
        {
          id: "nebulosas",
          nome: "Nebulosas",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/1sdprtlton1751464731504",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jlsswrhu5m1751464732308",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8dfdcklt3tw1751464737557",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/eymk4184ks51751464733967",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/vmwk0nb7iyo1751464737434",
          ],
        },
        {
          id: "exploracao_espacial",
          nome: "Exploração Espacial",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/o82j070fbr1751464755169",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/9hmqvzj858w1751464759851",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/gf8159r6m4g1751464767011",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/0i1981084w3v1751464758669",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/3b8l1v4buwv1751464759068",
          ],
        },
        {
          id: "vida_extraterrestre",
          nome: "Vida Extraterrestre",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/owzk8ypl2z81751464793388",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/tq29g23qykb1751464790748",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/o0sn691vmq1751464790400",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/v3lma9o8j8o1751464787790",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/f6auecilt151751464793592",
          ],
        },
      ],
    },
    {
      id: "historia",
      nome: "História",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/cp7z4jghq0a1749404620891",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ovebplstbm81749404620909",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/q8x25rrqs0o1749404622638",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/39vbv48hkl21749404626637",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/rd5ixv12yxh1749404621361",
      ],
      subcategorias: [
        {
          id: "revolucao_industrial",
          nome: "Revolução Industrial",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/tuf92edtdil1749404648427",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/byoa1i36tng1749404649249",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/5uz3phtvfiq1749404652916",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/lpxiffrttp1749404654159",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/txvqsbekmjp1749404649329",
          ],
        },
        {
          id: "civilizacoes_antigas",
          nome: "Civilizações Antigas",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/tyiw97hzer1749404702976",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/eu3o9a6meps1749404696313",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jtw7tsgffbi1749404691073",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xo7c58f6ws1749404699157",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/3p6jyr71xp21749404705968",
          ],
        },
        {
          id: "historia_antiga",
          nome: "História Antiga",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/spjz3v3ea1k1751464821274",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jql3b1a92ed1751464814495",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/k9nsqwv1kg1751464816932",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/pk8a3gw9l7o1751464817514",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/yfh2jv1gcds1751464814536",
          ],
        },
        {
          id: "idade_media",
          nome: "Idade Média",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xenmnsj6ubk1751464841797",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/domdgq997g61751464841722",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/cballoivvel1751464845370",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/sqcauugaqnc1751464843965",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/2lrl4zu1rdl1751464841848",
          ],
        },
        {
          id: "renascimento",
          nome: "Renascimento",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/3pv7jd81pdg1751464879617",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/eqp9shibevu1751464882929",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/py3jfh5b8w1751464880234",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/rudw7th9hdk1751464871542",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/yhqj8ci6p2n1751464874502",
          ],
        },
        {
          id: "primeira_guerra_mundial",
          nome: "Primeira Guerra Mundial",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/dinsoj86dw1751464912381",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/82f6aus7skq1751464908659",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8gr01uyhvib1751464910851",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/msuc1gf19l1751464901063",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ee9emxq6btc1751464907787",
          ],
        },
        {
          id: "segunda_guerra_mundial",
          nome: "Segunda Guerra Mundial",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/vr0gtx8jxw1751464932667",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/h8m3m8xti6j1751464943185",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/bdeurzqr0xl1751464937982",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ufdj3m2zdt1751464938695",
          ],
        },
        {
          id: "guerra_fria",
          nome: "Guerra Fria",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/j9vd10apvn1751464964705",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8mrxfl5r1d1751464964340",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/a711ame5021751464965603",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/zsmi4iiepgr1751464970528",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/huelj00qcyh1751464968732",
          ],
        },
        {
          id: "historia_do_brasil",
          nome: "História do Brasil",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/cf108zy7m6u1751464993658",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/j7q61e4l3p1751464994920",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/tftxsjvsjyn1751464997331",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/oyhs3x2q38b1751464991879",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nfuod5x6ue1751464990631",
          ],
        },
        {
          id: "revolucoes",
          nome: "Revoluções",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/bmzyh3nhpl91751465033740",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/zntehl5hqk1751465026359",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mnnmcu9y9kk1751465020128",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ykg6rxjf2t1751465032014",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/u8i8r7mw8tj1751465017715",
          ],
        },
        {
          id: "historia_contemporanea",
          nome: "História Contemporânea",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/02qkx5ubyh1751465056545",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/drwoipf46lo1751465054410",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/q49a5eghmod1751465052730",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/t04agb0osx1751465054758",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/i63ruv9v9t1751465056036",
          ],
        },
      ],
    },
    {
      id: "geografia",
      nome: "Geografia",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/f9ou89fxklh1749404747571",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/z9f0dbaj4th1749404752038",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mh9jr1hfnxo1749404746625",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/5q8vnmno0dd1749404742255",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/4s4pko0vhw1749404744256",
      ],
      subcategorias: [
        {
          id: "geopolitica",
          nome: "Geopolítica",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/83kilqrvd8g1749404786084",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/cmu9w5llhx61749404791041",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/n08pnrp4sbm1749404787515",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nqljp5bex9e1749404799130",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/0g28ariwq0h41749404792230",
          ],
        },
        {
          id: "meio_ambiente",
          nome: "Meio Ambiente",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/7pbxfav6wht1749404839127",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/rhortcwoqv1749404834577",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/h67b0ydls2r1749404835231",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/d9qit3f51eu1749404837579",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/9rpgfft74v81749404836211",
          ],
        },
        {
          id: "sustentabilidade",
          nome: "Sustentabilidade",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xoyatjzifrs1749404876345",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/fxf8j4m0mk1749404869140",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/7vq0q1eshpa1749404868594",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/cmytjnno9ik1749404874069",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/6eiuadc9a71749404873689",
          ],
        },
        {
          id: "geografia_fisica",
          nome: "Geografia Física",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/miaug1qd1n1751465081609",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/6t4vmo1133t1751465077945",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/fqa43s3ke8o1751465084723",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ou6v5vbssv1751465087134",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/pvhezvtl831751465082887",
          ],
        },
        {
          id: "geografia_humana",
          nome: "Geografia Humana",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/006b16cm2aqno1751465106697",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/dp2w587gff81751465113489",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/vype9qv6xm1751465107043",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/9hue0wxzcbe1751465110126",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/7azx0oehex1751465108811",
          ],
        },
        {
          id: "cartografia",
          nome: "Cartografia",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/36xt6aj993b1751465135202",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/07nl3jzfyseh1751465142341",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/y4hzwnspuv1751465134528",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/azk59d7nfqk1751465138887",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/hljzzdh6ggo1751465136148",
          ],
        },
        {
          id: "climatologia",
          nome: "Climatologia",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/4fozxhjm3z31751465167574",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/g2gyjd0z6951751465171153",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/82qctkvi90f1751465168518",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/m0irn2pffx1751465169190",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/rl65zbdg491751465167160",
          ],
        },
        {
          id: "geografia_urbana",
          nome: "Geografia Urbana",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/qvxpxy5p1cj1751465197820",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/1ffx2012jxw1751465192068",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/t8ws7c48mum1751465194033",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/dz2l5mtus7m1751465200083",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/qyyfs8gtptf1751465195646",
          ],
        },
        {
          id: "recursos_naturais",
          nome: "Recursos Naturais",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/q1wc4spwj2r1751465222411",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/73sl5x4d3gh1751465220694",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/1ewqs5cahf61751465221978",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/oy6rsi5z80r1751465220844",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jedhx58rqd1751465228518",
          ],
        },
        {
          id: "globalizacao",
          nome: "Globalização",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nsukezyonam1751465254479",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jv67giy5f5s1751465248467",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/tjqya8m8zdo1751465248166",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/iyc2731deug1751465251953",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/vz7i49sfmr1751465250060",
          ],
        },
      ],
    },
    {
      id: "filosofia",
      nome: "Filosofia",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/9655drkvmm1749404906443",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/pjz1tp9cazk1749404916097",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/rjwkqpatzp1749404899016",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/dped07tfm5h1749404898273",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/caqz29o7tkh1749404899947",
      ],
      subcategorias: [
        {
          id: "filosofia_antiga",
          nome: "Filosofia Antiga",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/7ezwpb9zy951751465277821",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/3e354y7xn471751465285109",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ifnob8m7l4h1751465276793",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/n4q7dos1ghf1751465279716",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jkqi77wvaic1751465277653",
          ],
        },
        {
          id: "filosofia_medieval",
          nome: "Filosofia Medieval",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/6jo3f1qskx1751465306663",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/yae2k563te1751465307834",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/9mx7wxytfv1751465305863",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ldcq0k5ouck1751465312536",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/23wridmdir41751465309997",
          ],
        },
        {
          id: "filosofia_moderna",
          nome: "Filosofia Moderna",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/zlwo7ettl71751465333944",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/lhtqo1ee3jh1751465332784",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/1ct0ac5s1jeh1751465335413",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/6vrp97hkv0n1751465330961",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/3u93ae2ckkq1751465334450",
          ],
        },
        {
          id: "filosofia_contemporanea",
          nome: "Filosofia Contemporânea",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ejzt7s1l2uh1751465359989",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/olxblx8dl3k1751465359484",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/evb8fsxnete1751465356012",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/u0z2zswrt4a1751465360216",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xk1jio46oe1751465371571",
          ],
        },
        {
          id: "etica_moral",
          nome: "Ética e Moral",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/kn9o21d6ywc1751465394771",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xmissi20tq1751465397171",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/92nq4qkbbuf1751465393005",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/1sqvtcu82kv1751465392302",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mvwczbnd7ue1751465392569",
          ],
        },
      ],
    },
    {
      id: "sociologia",
      nome: "Sociologia",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8okwhksb9h61749404956704",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/czfiukydvt1749404942489",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/by1kz2pxl4j1749404938425",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/421df0txzsu1749404939794",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/peicbz6ypdb1749404942808",
      ],
      subcategorias: [
        {
          id: "teorias_sociologicas",
          nome: "Teorias Sociológicas",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/2yqdxv3i8v31751465422029",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/zoczilz3gq81751465419054",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nctignmnuv1751465423374",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/0ri6qz79wkj1751465418290",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xb5hyzj8wxf1751465421552",
          ],
        },
        {
          id: "estrutura_social",
          nome: "Estrutura Social",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/pp53qygp7ec1751465440719",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/2ts0t0bbzwo1751465446148",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ctla24pyd281751465443809",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ewfpq2n5uj1751465444588",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/o0eri1mjczo1751465443442",
          ],
        },
        {
          id: "movimentos_sociais",
          nome: "Movimentos Sociais",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ibcx46pw83n1751465468314",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8re50xsrixt1751465471093",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/rsnonxnxwtl1751465468244",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/sm0qnez45m1751465466635",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/39r0gyqqaf21751465466598",
          ],
        },
        {
          id: "sociologia_urbana",
          nome: "Sociologia Urbana",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/5oflqz9ppsx1751465494067",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/2k3anv458mj1751465493994",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ppm88zdp6i1751465498753",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/77o1xhuim8i1751465493104",
          ],
        },
        {
          id: "sociologia_rural",
          nome: "Sociologia Rural",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8eto14k3rc1751465526655",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/v26rsukrokq1751465519127",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/49c8npwdwcb1751465521926",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/qpro96q1sdm1751465521764",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/aqvijgvse4a1751465536303",
          ],
        },
      ],
    },
    {
      id: "literatura",
      nome: "Literatura",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/t1n3kdtxv21749404983409",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/oeub0lckxhq1749404984902",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/p586kzo1fn1749404976165",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/9fdztw7rl11749404978611",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/gyimirl77c1749404977709",
      ],
      subcategorias: [
        {
          id: "poesia",
          nome: "Poesia",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/hwzewjwit6u1749405023098",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/87374ap21wj1749405028086",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/erm0qbsriir1749405031699",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/f491e0qakqf1749405027170",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/87tlxt8ofbc1749405025745",
          ],
        },
        {
          id: "narrativas",
          nome: "Narrativas",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/uc6vooz479n1749405070960",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/t8lu92mu7gc1749405072040",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/etnzs1qnrle1749405070843",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/n7avx7dqrb1749405060609",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/s72zhjy6w281749405063912",
          ],
        },
      ],
    },
    {
      id: "idiomas",
      nome: "Idiomas",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/3f4vyz5fqss1749405098804",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/tpjp49ehef81749405097638",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ji7p4i2111749405097656",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/1yo8hy0acaj1749405111576",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/72m7kuji48d1749405099624",
      ],
      subcategorias: [
        {
          id: "ingles",
          nome: "Inglês",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/7fkuc4zt2ae1749405146425",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/19kgavcppam1749405144350",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/71d5xczq24a1749405152373",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/fbq23cb96q1749405146760",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/aq8fqlf0sy1749405151012",
          ],
        },
        {
          id: "espanhol",
          nome: "Espanhol",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/duk77z3po091749405195067",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jbuzmmud521749405194354",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/0bmvwr8p10bw1749405195617",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/tqmku2f761g1749405202494",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/5u1bd6c9e8g1749405193435",
          ],
        },
        {
          id: "frances",
          nome: "Francês",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/9wi7bkqmkx1749405241589",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/qeef5ng9ox1749405239609",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xf7cxh2z0u1749405243611",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jbmv5xbp63s1749405238463",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8jyxhdy3uf1749405240996",
          ],
        },
      ],
    },
    {
      id: "artes",
      nome: "Artes",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xtxjdrpefzs1749405269764",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ka0glwz4fr81749405275728",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/6uzr41wlyo71749405268831",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/i42xdl40pba1749405269094",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/pjsgidirrta1749405281226",
      ],
      subcategorias: [
        {
          id: "musica",
          nome: "Música",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/zldx4fxzoyq1749405310130",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/faltqsob52k1749405308398",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/uuibcwe8q9k1749405310962",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/qqiss32wi1749405314504",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ua2keotgl2q1749405309883",
          ],
        },
        {
          id: "teatro",
          nome: "Teatro",
          imagens: [
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/bilzz2442lv1749405337958",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/z2sada2sk8d1749405340118",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/rsno17fpts81749405334069",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/m96w2j92zy1749405340862",
            "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/bagb5dpai8t1749405336824",
          ],
        },
      ],
    },
    {
      id: "educacao_fisica",
      nome: "Educação Física",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/k9e395gae71749405376771",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/koff898h9a1749405383897",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/oo9j6te8vmi1749405384073",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mg051cno1k1749405376894",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/d2m9wccog51749405390295",
      ],
    },
  ],
  metodologias_ensino_aprendizagem: [
    {
      id: "aprendizagem_ativa",
      nome: "Aprendizagem Ativa",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8wps7j3sqpf1749405466057",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/yq97xiqsj5i1749405461212",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ujpslh2om3m1749405463921",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/vwc7mxeritg1749405458555",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/loucyrojc9r1749405459603",
      ],
    },
    {
      id: "aprendizagem_colaborativa",
      nome: "Aprendizagem Colaborativa",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ijlu1wboi41749405512876",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/c1ji8jxk67k1749405512641",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/v6ww1v9a2691749405511474",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/u2l009dbual1749405511277",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/0sp2rpecfcei1749467818830",
      ],
    },
    {
      id: "aprendizagem_ludica",
      nome: "Aprendizagem Lúdica",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jogs183iptd1749405536470",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/rxxdcngd60k1749405539061",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/te1w0guyuts1749405535394",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/kqltuqz9qli1749405540792",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nfctlo5zba1749405542058",
      ],
    },
    {
      id: "ensinar_aprendendo",
      nome: "Ensinar Aprendendo",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/rcjguyg3gwm1749405573067",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8k45xq5ufcw1749405576451",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/42kiwf5bz0x1749405566057",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/cgux0vasmx91749405565191",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/bkaea49jwxn1749405563696",
      ],
    },
    {
      id: "aprender_brincando",
      nome: "Aprender Brincando",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8mzx92zigmd1749405607705",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/82e2qknfdaf1749405599217",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/o1a3v3r4bp1749405605915",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/pvgeskrbli1749405596913",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ibryo1ch0rh1749405602300",
      ],
    },
    {
      id: "sala_aula_invertida",
      nome: "Sala de Aula Invertida",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/lfel2k5jvh1749405636981",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/z9bqx8a1k21749405638874",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/041224egq4sb1749405633412",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xdlcqc91xvm1749405639959",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/u6z16n4x3cf1749405641606",
      ],
    },
    {
      id: "metodologia_ativa",
      nome: "Metodologia Ativa",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/75u6hoo2k5w1749405685387",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/5qybe3jsy81749405680153",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/urv8yhv1l7m1749405679302",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/vauxtl21c9c1749405694576",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/j3isjglryz1749405678332",
      ],
    },
    {
      id: "estudo_caso",
      nome: "Estudo de Caso",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/pseadcj94li1749405736810",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/sml2dimnzxg1749405735325",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/60dlccvg29t1749405740923",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/95mgltg0reg1749405732087",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/7wy12ahiurm1749405750591",
      ],
    },
    {
      id: "interdisciplinaridade",
      nome: "Interdisciplinaridade",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/94j7mkjydoe1749405780589",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/j4kzid5ufln1749405781020",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/s0osziv45f1749405780995",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/gim38kui9g1749405788692",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/1akausk2t0e1749405789269",
      ],
    },
    {
      id: "laboratorio_criativo",
      nome: "Laboratório Criativo",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/umagunrl8q1749405815503",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/o57n1eka7t1749405816619",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/i8mhivon931749405817030",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/1elia3grbmd1749405817378",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xp84h2krcm81749405838893",
      ],
    },
    {
      id: "pesquisa_cientifica",
      nome: "Pesquisa Científica",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/d3vz8a0jb21749405866257",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mg7edanga1749405860382",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ewgsnmawdf1749405865765",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/9oi782c7m7w1749405868253",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/7bkwak3yhur1749405869805",
      ],
    },
    {
      id: "projetos_grupo",
      nome: "Projetos em Grupo",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/d3y7zc3q2n41749405905705",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/tmoyh7n38vn1749405904840",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/04q9rxad54zw1749405911189",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/q1ok22p6dr1749405904640",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/htwnr72xtri1749405905386",
      ],
    },
    {
      id: "resolver_problemas",
      nome: "Resolver Problemas",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/9n9jg1qu62c1749405948304",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/pjldcssskq1749405942821",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/9rc30vsbtk1749405944595",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/f4pt000jr8b1749405944606",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/zynwlu27kc1749405942608",
      ],
    },
    {
      id: "pensamento_critico",
      nome: "Pensamento Crítico",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/orpudpcti3l1749405980353",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/sxjneri2y51749405988648",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/j1do2oqsa5s1749405981101",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jgbpiwsfk71749405982208",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/64qzksso08a1749405987298",
      ],
    },
    {
      id: "desenvolvimento_cognitivo",
      nome: "Desenvolvimento Cognitivo",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/b5417yhrx271749406008742",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/b43nx5d4g11749406016894",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/vom5by2c2p1749406009936",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mjfu2pjpsos1749406010561",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/si5pydxc0bb1749406008874",
      ],
    },
    {
      id: "inteligencia_emocional",
      nome: "Inteligência Emocional",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jlzwsjf7ec1749406051210",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/k0294592o5b1749406053941",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8lttfwlyzdb1749406052690",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/su4gpk6afq81749406055229",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/lrd5ej7cf91749406078749",
      ],
    },
    {
      id: "habilidades_sociais",
      nome: "Habilidades Sociais",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xbzy021im4p1749406098251",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/aco501asnm51749406109136",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/trmvln4ko3e1749406100408",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/fgdqsy36ag1749406107863",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ml5rcocc3rb1749406113902",
      ],
    },
    {
      id: "mente_inquieta",
      nome: "Mente Inquieta",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/9o8hskn10ep1749467857267",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/a8yemklbbvc1749467852496",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/548i1nnbl4t1749467855529",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/eje5nwa81nc1749467852617",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/yj0zrlvnfm1749467850432",
      ],
    },
    {
      id: "criando_conhecimento",
      nome: "Criando Conhecimento",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nkdf2c9iylj1749467889013",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ycv1cshaqy1749467896671",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/7fahj490591749467888098",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/2s53rtcxikp1749467896862",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/6tl1id74zpg1749467897047",
      ],
    },
    {
      id: "sempre_aprendendo",
      nome: "Sempre Aprendendo",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/an7dwpl8m91749467933559",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jryjh0hw4a71749467928905",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/qscs2l8e5v1749467935818",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/i5uah3yr30j1749467932589",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xdqev7aymp1749467931422",
      ],
    },
    {
      id: "quebra_rotina",
      nome: "Quebra de Rotina",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nsiuz5n14cm1749467976241",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/b33u2ib6fdq1749467972670",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ro9c65gtidp1749467962654",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/6y77gv411l1749467964773",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/52lgt56f6g31749467967532",
      ],
    },
    {
      id: "desafio_semanal",
      nome: "Desafio Semanal",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/6xqtjcdj9vi1749468001957",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/lxdkyxzy77b1749468002745",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8jatv77ttyl1749468003407",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/05rawbd9sn71749468001396",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/hrdq1b7cegm1749468011671",
      ],
    },
    {
      id: "desafio_surpresa",
      nome: "Desafio Surpresa",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jpesv1qews1749468073746",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/0xt34au70bo1749468076917",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/72008jspurk1749468071586",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/hu7gk58l1uk1749468075841",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nf2p1y96c1749468079791",
      ],
    },
    {
      id: "missao_especial",
      nome: "Missão Especial",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/vj3fwdzupme1751465563680",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/2aaxhgb4tnk1751465564805",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/pgxyope0ol1751465558699",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/hddiio9exh1751465567160",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/usbgfj0ltx91751465564073",
      ],
    },
    {
      id: "conteudo_bonus",
      nome: "Conteúdo Bônus",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/zchofdht2ip1749468121038",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/skc4q9kun11749468113174",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/fse98a9nyrq1749468112139",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mtocy7ykpoq1749468109687",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/sa1dfyufr31749468108064",
      ],
    },
    {
      id: "revisao_geral",
      nome: "Revisão Geral",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/a46zru3dvlm1749468146479",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/50x8b036evb1749468141206",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/7jkiz4jtc1g1749468152850",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/lsb6o0wgcz1749468146176",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/p0euhkx4y11749468142786",
      ],
    },
    {
      id: "mentoria_especial",
      nome: "Mentoria Especial",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/txkif3bjdea1749468189320",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/2kngvudijsa1749468181093",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/yjhrxhf4sqn1749468182832",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/k57b1tadapd1749468192707",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/62v8r1m9yi21749468180378",
      ],
    },
    {
      id: "desafio_complementar",
      nome: "Desafio Complementar",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ls5b4spzjgd1749468211498",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nljye7okyfp1749468213407",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ztahjc46b8c1749468214292",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/v38d8bfqyh1749468209847",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/39ue0cdxu041749468212294",
      ],
    },
    {
      id: "projeto_integrador",
      nome: "Projeto Integrador",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/4evlkvgtu241749468252978",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/wa46gir3wtj1749468254430",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jrsroexjrmf1749468248366",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/hftl5rcbo1o1749468248109",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/rnf2eazsgei1749468256588",
      ],
    },
    {
      id: "jornada_conhecimento",
      nome: "Jornada do Conhecimento",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/lbqbt0w1lo71749468277381",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/54e0lukrvxf1749468277848",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/qnjnv94yn5a1749468280075",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/lucr92s9nxe1749468278186",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/lxh3gfsx1op1749468283935",
      ],
    },
  ],
  tecnologia_inovacao: [
    {
      id: "informatica",
      nome: "Informática",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/r2y49lor81q1749468339066",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/l5r480afttk1749468335878",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/pahrtz76o7f1749468334569",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/cmzb68feryt1749468335252",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/hen9vea5sqk1749468341092",
      ],
    },
    {
      id: "programacao",
      nome: "Programação",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/kgdiyg7f1en1749468370899",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/kylfteeg1en1749468364802",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/q5ek1gj5wu1749468367635",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/iodu7ggga5c1749468372233",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/q6xmc9pavt81749468362977",
      ],
    },
    {
      id: "robotica",
      nome: "Robótica",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8fj2x11lj771749468398623",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/w02k8owehcp1749468392929",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/wz8n8lynxa1749468405267",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nam7ft08gnp1749468394447",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/c251s914ir1749468394015",
      ],
    },
    {
      id: "tecnologia",
      nome: "Tecnologia",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/l72zpb6cs91749468434185",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xf7kttrj7j1749468427083",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/gv8vboht6cr1749468433718",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/fhe6qkz9cxt1749468433489",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/oxah0ays9m1749468426687",
      ],
    },
    {
      id: "interacao_digital",
      nome: "Interação Digital",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mhvregow2f1749468456902",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/qnr7jyjohri1749468456120",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xcu3ugq2zn1749468457394",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/o3rcny8qveg1749468455072",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/dkhjc73pc0s1749468454381",
      ],
    },
    {
      id: "aprendizagem_remota",
      nome: "Aprendizagem Remota",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/5yozwnaoxxu1749468479374",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/0zw0gi4gofgb1749468480430",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ibqbrz45op1749468479316",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/m9rk4qjs9h1749468481656",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ivtiog0svlg1749468481563",
      ],
    },
    {
      id: "conexao_global",
      nome: "Conexão Global",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/9v1adiaipqk1749468502955",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/p3q398l4umb1749468510020",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/4p5mchmiuq1749468504404",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/2xf5oetzq0c1749468504836",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/e0hacvqnmo1749468505506",
      ],
    },
    {
      id: "habilidades_futuro",
      nome: "Habilidades do Futuro",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/79m84qm8oqj1749468532417",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ogs80pchxll1749468536547",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/73mb3jb2gbq1749468533188",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/6elnsfnnw4r1749468535106",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xwkpqjngn41749468532377",
      ],
    },
  ],
  vida_escolar_eventos: [
    {
      id: "nossa_escola",
      nome: "Nossa Escola",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/r21tg6bf411749468601879",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/o550ew1fgc1749468601392",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jgrs5gkvmm91749468592328",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/kws4308usx1749468592541",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/x7rwcyzukzk1749468597771",
      ],
    },
    {
      id: "feira_ciencias",
      nome: "Feira de Ciências",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/asz8m034u5d1749468640024",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/yl7t7ezynnj1749468626912",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/fg4r2jajr3g1749468623296",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/g3p0txef22w1749468632026",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/gbw322ze4to1749468626450",
      ],
    },
    {
      id: "olimpiada_conhecimento",
      nome: "Olimpíada do Conhecimento",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/n38mhnayd51749468663283",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/n2urmef6iqh1749468665153",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/qn63axahcno1749468669810",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nz8h8uaw611749468666457",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/fvly6yd78kp1749468668505",
      ],
    },
    {
      id: "festival_artes",
      nome: "Festival de Artes",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/9965oyh7ne1749468711969",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/0cr54akt7gll1749468699644",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/fn4ae53mmo71749468698884",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xu8x42yepo1749468710645",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/v9okff5mk991749468700724",
      ],
    },
    {
      id: "mostra_cultural",
      nome: "Mostra Cultural",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/yhsp98gvb81749468739389",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/u2e13fmlh8p1749468737351",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/k9wkp8flet1749468745092",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/em2t2azlm4t1749468740812",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ztvzml0xrr1749468737051",
      ],
    },
    {
      id: "concurso_leitura",
      nome: "Concurso de Leitura",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/4b10800xu391749468778723",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/63rpk3ek7x1749468789941",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/53v3b0dt2t21749468771274",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/3xzaaozl3e71749468778482",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/5muroykav1h1749468777672",
      ],
    },
    {
      id: "gincana_educativa",
      nome: "Gincana Educativa",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/i9xj4dn7xpj1749468825983",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/vhho3bpixkd1749468810821",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/pco0r9e3imp1749468827827",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/pbhnham3z9g1749468818168",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/0j4p9usotqx1749468815634",
      ],
    },
    {
      id: "torneio_debates",
      nome: "Torneio de Debates",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/3i440gibmfi1749468857096",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/3tq7saxtedk1749468854789",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/dq9st6w02t41749468849637",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/3nuhvbcldo91749468850122",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/5w6qtajr3n1749468857031",
      ],
    },
    {
      id: "festa_literaria",
      nome: "Festa Literária",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/sm6f5nf2yh91749468877565",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/l22pph7gvbg1749468879363",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/c7z7fabks61749468888608",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/50x2cfge3i21749468888732",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/w5qiz6kcc2i1749468886578",
      ],
    },
    {
      id: "semana_tematica",
      nome: "Semana Temática",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8pg9ou80c9n1749468912886",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/bpzfg3pwf1f1749468924096",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/u88l0kdajhk1749468923283",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/f5oeqduz2er1749468920687",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/2d2lg9crjrb1749468922403",
      ],
    },
    {
      id: "expo_ciencias",
      nome: "Expo Ciências",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xxexhuock51749468949542",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ewd1lz77poj1749468949976",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/3abizdcfyl21749468947756",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/tqybpws9rhp1749468948720",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ffne7lj0onh1749468955637",
      ],
    },
    {
      id: "maratona_academica",
      nome: "Maratona Acadêmica",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/roovyje5jlb1749468983993",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ltwb7xr9971749468978431",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/q9v2tlzbnkl1749468976185",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/7lgby833ozw1749468977607",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nzdm0xnrw3d1749468978736",
      ],
    },
    {
      id: "forum_ideias",
      nome: "Fórum de Ideias",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/k1op1lq71ve1749469020846",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/436er1y16rl1749469006917",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/4kujetd2oyv1749469008438",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/c180cqkoi481749469003777",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/y9vf3t0xcqa1749469006239",
      ],
    },
    {
      id: "encontro_jovens_lideres",
      nome: "Encontro de Jovens Líderes",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/4nupmamqoej1749469051870",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/28qcpbxj9h11749469047991",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/cyrv2yia05s1749469051005",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/p23ojtqp6l1749469042614",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/qmz4zijboc71749469055359",
      ],
    },
    {
      id: "festival_robotica",
      nome: "Festival de Robótica",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/6ehpz0d8q071749469076019",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/38gw667dzlt1749469081495",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/l0h8rt0dac1749469074175",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/29ybwilfish1749469074793",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/1j4a4m6ea0u1749469075596",
      ],
    },
    {
      id: "reuniao_pais",
      nome: "Reunião de Pais",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/zgh7kzatru1749469109229",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ny1np0hwu11749469111672",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/9l5baqhkqcv1749469108660",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ir0u8ml4e5n1749469100231",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jrmb8xeef5n1749469108589",
      ],
    },
    {
      id: "entrega_boletins",
      nome: "Entrega de Boletins",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/90kb630tvq81749469132430",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/p2l4jnvs4v1749469134132",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/48oz8v56r251749469134409",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jx1villzol1749469133765",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/48wrzdalpp71749469144118",
      ],
    },
    {
      id: "formaturas_turmas",
      nome: "Formaturas de Turmas",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/pn9c2vh6zo1749469172018",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/irdvu1m50ve1749469169552",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/w2degb88f7g1749469172845",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/0guviw5f0f1t1749469169876",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/y2jqjk3tmx81749469168987",
      ],
    },
    {
      id: "semana_provas",
      nome: "Semana das Provas",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ilgxzpd7xbd1749469196937",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/puonlkwgqc1749469195061",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/d1jpa8w4oco1749469210423",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/b9ke45yiy61749469207959",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/shmf3u7cca91749469198119",
      ],
    },
    {
      id: "recuperacao_final",
      nome: "Recuperação Final",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/67do5ov9qu71749469232249",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/rycftlz5631749469238430",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/k2uxnfmmrps1749469232295",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/wgnesrgz4j81749469234194",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/dgrhyg8vt491749469236388",
      ],
    },
    {
      id: "inicio_bimestre",
      nome: "Início do Bimestre",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/2ujvhqemw8p1749469261944",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8h41ocyx84f1749469261904",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ccqst6b9dit1749469268809",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/q0ojslcev21749469273736",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/wsa39ids991749469269396",
      ],
    },
    {
      id: "volta_aulas",
      nome: "Volta às Aulas",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/0x2x96u4olo1749469300747",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/s6voeuf4sh1749469304130",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/fke4qmxkrr1749469294444",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/i1hpaao7vkj1749469297631",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/fpn9j58rmpi1749469295790",
      ],
    },
    {
      id: "vespera_feriado",
      nome: "Véspera de Feriado",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/r1rf7k7n6c81749469328526",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/4aaq08korc61749469331929",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/tky8em37rf1749469329811",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/hb2igg29k51749469329588",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xjphl3dn2tj1749469328126",
      ],
    },
    {
      id: "encerramento_ano",
      nome: "Encerramento do Ano",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/llv84mu9q2h1749469367955",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/pmzg0vq0h1l1749469353577",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nd2o5g9fm81749469359969",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/4jx8tsjpkyg1749469352398",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/i6xz6xnu3da1749469349999",
      ],
    },
    {
      id: "matriculas_abertas",
      nome: "Matrículas Abertas",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nm5el7csrm1749469389886",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/yszy28ktmj1749469393598",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/symmmpxjcl1749469401769",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mgysuh1um191749469401443",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/yr3ke8t6kw1749469404712",
      ],
    },
  ],
  valores_missao_cultura: [
    {
      id: "excelencia_educacional",
      nome: "Excelência Educacional",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/dd26z214a871749469451392",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/82h5xs8tphu1749469452708",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/9gbf1yvgx951749469450283",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nadofaz39p1749469451338",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/u9cs7ut7271749469467094",
      ],
    },
    {
      id: "educacao_transforma",
      nome: "Educação que Transforma",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/vh1oy6wjshk1749469493003",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8ugnngca3cc1749469488810",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/c07og54legv1749469487875",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nof1rcywhcl1749469502674",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/bzlmkzwtj7m1749469487282",
      ],
    },
    {
      id: "formando_lideres",
      nome: "Formando Líderes",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/z49ugcuir6h1749469530908",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/469mzkz6gl91749469526379",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/79p0s8n43ri1749469523553",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ubor6h878im1749469535384",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/67lcufvicbf1749469525299",
      ],
    },
    {
      id: "tradicao_qualidade",
      nome: "Tradição de Qualidade",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/3mc20chsohc1749469565906",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/3zsbt3djbr31749469556358",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/juldd6p4geq1749469556977",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/8w6j1eaa0k71749469554871",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/qwcrdb6lk1749469564722",
      ],
    },
    {
      id: "espaco_sabedoria",
      nome: "Espaço de Sabedoria",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/a1rlsdff4k61749469588235",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/us7cl3lj8y1749469588721",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/qu31rrzx61h1749469589097",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/jnisch7b1oq1749469589909",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mrfybxhi8rl1749469590006",
      ],
    },
    {
      id: "comunidade_escolar",
      nome: "Comunidade Escolar",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/o7e4wtua2q1749469624064",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/kjz7dpuyg81749469622495",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/29awjkt3ms1749469623153",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/u0i0g69xbh91749469630766",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/yuibiq5590o1749469622862",
      ],
    },
    {
      id: "valores_educacionais",
      nome: "Valores Educacionais",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/uh5m24hesjp1749469690261",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/kilkb1moxp1749469687653",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/51l4lozev7g1749469686188",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/5gu5ykne9xl1749469688395",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/2zntemv29l41749469687034",
      ],
    },
    {
      id: "parceria_familia_escola",
      nome: "Parceria Família-Escola",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/6s6dov1nqo91749469717755",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/vwp4di6q8yi1749469718055",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/13xb0hvnuxda1749469714299",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/2g65v70bksi1749469719217",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/dnmn3n04hsd1749469729276",
      ],
    },
    {
      id: "credibilidade_reconhecida",
      nome: "Credibilidade Reconhecida",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/zj4qj9bd0kn1749469753791",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ho0vxmo0p641749469751546",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/i0gvd8pa91q1749469753489",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/aw13dvc9xi1749469752139",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/auxuh41mgpl1749469750954",
      ],
    },
    {
      id: "resultados_excepcionais",
      nome: "Resultados Excepcionais",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/93uxem8taop1749469778380",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/r2up3bq5d6m1749469777272",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/20msxnxkvx11749469783972",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/fy1578zu4f61749469776988",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/qno29y7give1749469777992",
      ],
    },
    {
      id: "profissionais_dedicados",
      nome: "Profissionais Dedicados",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/rbgpt78peif1749469802842",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/06iad3qtmbea1749469805732",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/d71ea86iuck1749469805626",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ldoatmv7ky1749469811532",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/63uloja9xwe1749469806031",
      ],
    },
    {
      id: "equipe_compromissada",
      nome: "Equipe Compromissada",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/luzvypw4oke1749469833261",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/npltb0ej1e1749469844939",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/0px141ghioxh1749469836028",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/atxahai13pr1749469831666",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/zxnff59u611749469842634",
      ],
    },
    {
      id: "ensino_inovador",
      nome: "Ensino Inovador",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/a4eilnqsb2p1749469865957",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/mkh33f4cyzn1749469870850",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/ozjlsytk5w1749469867189",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/oduroxqg4y1749469867106",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/xwn9fjnkf5g1749469868337",
      ],
    },
    {
      id: "metodologia_exclusiva",
      nome: "Metodologia Exclusiva",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/4irlajysanf1749469891162",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/x0m9ukjj0io1749469891238",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nph1bptr52m1749469891321",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/861opcxxbo31749469908886",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/wnl2qcqwb2d1749469892370",
      ],
    },
    {
      id: "infraestrutura_moderna",
      nome: "Infraestrutura Moderna",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/48h07x1e55m1749469936576",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/es1muxhstqi1749469933115",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/0xiegddh61p1749469929475",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/u6xqyiqeg0r1749469938386",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/nj6y61aukdg1749469938510",
      ],
    },
    {
      id: "alunos_destaque",
      nome: "Alunos Destaque",
      imagens: [
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/55txbysniev1749469966131",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/vm687nog4c1749469959711",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/i6exxnb4z4a1749469971474",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/thhusme356b1749469961085",
        "https://static-gamefik-com.s3.us-west-002.backblazeb2.com/k0sr945z6qm1749469970985",
      ],
    },
  ],
};

let cachedAllImages: string[] | null = null;

const collectAllImagesFromBank = (): string[] => {
  if (cachedAllImages) return cachedAllImages;
  const allImages: string[] = [];

  Object.values(rawCategoriasData).forEach((mainCategory: any) => {
    if (!Array.isArray(mainCategory)) return;
    mainCategory.forEach((category: any) => {
      if (Array.isArray(category?.imagens)) {
        allImages.push(...category.imagens);
      }
      if (Array.isArray(category?.subcategorias)) {
        category.subcategorias.forEach((subCategory: any) => {
          if (Array.isArray(subCategory?.imagens)) {
            allImages.push(...subCategory.imagens);
          }
          if (Array.isArray(subCategory?.subcategorias)) {
            subCategory.subcategorias.forEach((nested: any) => {
              if (Array.isArray(nested?.imagens)) {
                allImages.push(...nested.imagens);
              }
            });
          }
        });
      }
    });
  });

  cachedAllImages = allImages;
  return allImages;
};

export const getRandomImageFromBank = (): string => {
  const allImages = collectAllImagesFromBank();
  if (allImages.length === 0) return "";
  const randomIndex = Math.floor(Math.random() * allImages.length);
  return allImages[randomIndex] ?? "";
};
